import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { LayoutContext } from 'contexts/LayoutContext';
import { View } from 'dripsy';
import { useCallback, useContext, useEffect, useState } from 'react';
import { AccountManagementStackRoutes, AccountManagementStackScreenProps } from '../../account.navigator';
import { ModalContainerView } from '../../../account-management/components/ModalContainerView';
import { WithdrawMain } from './WithdrawMain';
import { WithdrawConfirm } from './WithdrawConfirm';
import { WithdrawPlaced } from './WithdrawPlaced';
import { WithdrawStackParamList, WithdrawStackRoutes } from './type';

const WithdrawStack = createNativeStackNavigator<WithdrawStackParamList>();

export const WithdrawNavigator: React.FC<AccountManagementStackScreenProps<AccountManagementStackRoutes.Withdraw>> = ({ route }) => {
  const { func, refresh, record } = route.params;
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const layout = useContext(LayoutContext);

  useEffect(() => {
    if (!layout.isMobile) return;
    setDimensions(layout.dimensions);
  }, [layout.dimensions]);

  const onLayout = useCallback((event) => {
    const { width, height } = event.nativeEvent.layout;
    setDimensions({ width, height });
  }, []);

  const [data, setData] = useState(undefined);
  const onData = (data: any) => {
    setData(data);
  };

  const [returnData, setReturnData] = useState(undefined);
  const onReturnData = (data: any) => {
    setReturnData(data);
  };

  return (
    <ModalContainerView dimensions={dimensions}>
      <View sx={{ height: dimensions.height, width: dimensions.width }} onLayout={onLayout}>
        <WithdrawStack.Navigator
          initialRouteName={WithdrawStackRoutes.Main}
          screenOptions={{
            presentation: layout.isMobile ? 'modal' : 'transparentModal',
            headerShown: false
          }}>
          <WithdrawStack.Screen
            name={WithdrawStackRoutes.Main}
            component={WithdrawMain}
            initialParams={{ onLayout, onData, onReturnData, func, refresh, record }}
            options={{ headerShown: false }}
          />
          <WithdrawStack.Screen
            name={WithdrawStackRoutes.Confirm}
            component={WithdrawConfirm}
            initialParams={{ onLayout, data, onReturnData, func, refresh, record }}
            options={{
              presentation: 'transparentModal',
              headerShown: false,
              contentStyle: {
                backgroundColor: 'transparent'
              }
            }}
          />
          <WithdrawStack.Screen
            name={WithdrawStackRoutes.Placed}
            component={WithdrawPlaced}
            initialParams={{ onLayout, data, returnData, record }}
            options={{ presentation: layout.isMobile ? 'modal' : 'transparentModal', headerShown: false }}
          />
        </WithdrawStack.Navigator>
      </View>
    </ModalContainerView>
  );
};
